import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};


/**********************************
 *
 *      Site Stuff
 *
 * ********************************/
import {onFind} from "@elements/init-modules-in-scope";

import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as parallax from './scripts/parallax';
parallax.init();

import * as fadeIn from './scripts/fade-in';
fadeIn.init();

import * as scrollingArea from './scripts/scrolling-area';
scrollingArea.init();

import * as scrollHint from './scripts/scroll-hint';
scrollHint.init();

import * as tilt from './scripts/tilt';
tilt.init();

import 'bootstrap/js/dist/modal';

import * as infoModal from './scripts/info-modal';
infoModal.init();

import * as locationMapLeaflet from './scripts/location-map-leaflet';
locationMapLeaflet.init();